module.exports = __webpack_public_path__ + "img/um-lugar-experiencia.b9b3ab78.png";